import { Controller } from "@hotwired/stimulus"
import { get } from '@rails/request.js'

export default class extends Controller {
  static targets = ["results", "search"]
  static values = { path: String }

  connect() {
    this.widgetParams = { page: 1, per_page: 3 }
    this.options = {
      tag: "program-filter-search-results",
      widget_action: "search_results"
    }
    this.filter_names = [
      "direction_ids",
      "grade_ids",
      "form_ids",
      "city_ids",
      "difficulty_ids",
      "duration_ids",
      "sort"
    ]
    
    // Слушаем события от фильтров
    this.element.addEventListener("filter:filter-applied", this.handleFilterApplied.bind(this))
    this.element.addEventListener("tags:filter-applied", this.handleFilterApplied.bind(this))
    this.element.addEventListener("sort:filter-applied", this.handleFilterApplied.bind(this))
    // this.element.addEventListener("sort:filter-applied", this.handleSort.bind(this))
  }

  handleFilterApplied(event) {
    const { name, values } = event.detail
    this.dispatch(`filter-${name}-updated`, {detail: { name, values }});
    this.widgetParams[name] = values
    this.cleanSearch()
    this.applyFilters()
  }

  // handleSort(event) {
  //   const { name, values } = event.detail
  //   this.widgetParams['sort'] = values
  //   this.applyFilters()
  // }

  onResetFilters() {
    this.resetFilters()
    this.applyFilters()
  }

  onSearch(event) {
    event.preventDefault();
    const query = this.searchTarget.value.trim();
    if (!query) return;
    this.resetFilters();
    this.widgetParams['search'] = query;
    this.applyFilters();
    this.scrollToResults();
  }

  scrollToResults() {
    const resultsBlock = this.resultsTarget;
    const offset = 140;
    if (resultsBlock) {
      const top = resultsBlock.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }

  onOrder(event) {
    this.widgetParams['order'] = event.currentTarget.value
    this.applyFilters()
  }

  cleanSearch() {
    this.widgetParams['search'] = ''
    this.searchTarget.value = ''
  }

  resetFilters() {
    this.filter_names.forEach(name => {
      this.dispatch(`filter-${name}-updated`, {detail: {name, values: []}});
      this.widgetParams[name] = []
    })
  }

  async applyFilters() {
    this.options.widget_params = this.widgetParams
    
    // Формируем правильные query параметры с использованием URLSearchParams
    const queryParams = this.flattenParams(this.options);
    
    // Отправляем запрос с правильными параметрами
    try {
      await get(this.pathValue, {
        query: queryParams,
        responseKind: 'turbo-stream'
      });
    } catch (error) {
      console.error('Error applying filters:', error);
    }
  }

  // Функция для преобразования вложенных объектов в плоский список параметров
  flattenParams(obj, prefix = '') {
    const params = new URLSearchParams();

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const paramKey = prefix ? `${prefix}[${key}]` : key;
        const value = obj[key];

        if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
          // Рекурсивно обрабатываем вложенные объекты
          const nestedParams = this.flattenParams(value, paramKey);
          for (const [nestedKey, nestedValue] of nestedParams) {
            params.append(nestedKey, nestedValue);
          }
        } else if (Array.isArray(value)) {
          // Обрабатываем массивы специальным образом для Rails
          value.forEach(item => {
            params.append(`${paramKey}[]`, item);
          });
        } else {
          // Обрабатываем простые значения
          params.append(paramKey, value);
        }
      }
    }

    return params;
  }
}
